import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RevService } from '@shared/services/rev.service';

@Component({
    selector: 'rev-doc-view-dispatch',
    templateUrl: './rev-doc-view-dispatch.component.html',
    styleUrl: './rev-doc-view-dispatch.component.scss',
    standalone: false
})
export class RevDocViewDispatchComponent implements OnInit {

  constructor(
    private router: Router, 
    private route: ActivatedRoute,
    private revService: RevService
  ) { }

  ngOnInit(): void {
    const queryParams = this.route.snapshot.queryParams;

    this.revService.getRevDocViewInfo(queryParams).subscribe(
      ({ env_id, doc_id }) => {
        let qpObject = {
          dl: 1,
          env: env_id,
          revdoc: doc_id,
          page: 1
        };
        this.router.navigate(['/login'], { queryParams: qpObject });
      },
      (error) => {
        console.error('Failed to get rev doc view info', error);
        this.router.navigate(['/login']);
      }
    );
  }

}
